import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import { SolvTheme } from '@solvhealth/jigsaw-v1';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../constants/colors';
import { biggerThan, smallerThanOrEqualTo } from '../../../../../core/util/styledComponents';
import { SWIMLANE_SPACING } from '../../../../Account/Profile/FindCare/util';
import { getColumnCount } from '../../../../Account/Profile/Insurance/util/tileConfig';
import TileFactory from '../util/TileFactory';

const Root = styled.div.withConfig({ componentId: 'sc-b19lx4-0' })`
  padding: 0;

  ${smallerThanOrEqualTo.sm`
    padding: 0;
    margin: 0 -${SWIMLANE_SPACING / 2}px;
  `};
`;

const List = styled(GridList).withConfig({ componentId: 'sc-b19lx4-1' })`
  // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
  transform: translateZ(0);
  flex-wrap: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'wrap' does not exist on type 'GridListPr... Remove this comment to see the full error message
    props.wrap ? 'wrap' : 'nowrap'};
  & > li:first-child {
    margin-left: ${(props) =>
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'wrap' does not exist on type 'GridListPr... Remove this comment to see the full error message
      props.wrap ? '0' : `${SWIMLANE_SPACING / 2}px`};
  }

  ${biggerThan.sm`
    & > li:first-child {
      margin-left: ${(props: any) => (props.wrap ? '0' : '16px')};
    }
  `}
`;

const TileContainer = styled.div.withConfig({ componentId: 'sc-b19lx4-2' })`
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  background-color: ${colors.white};
  box-shadow: ${SolvTheme.shadows.sm};
  box-sizing: border-box;
`;

const GridTile = styled(GridListTile).withConfig({ componentId: 'sc-b19lx4-3' })`
  > div {
    overflow: visible;
  }

  box-sizing: border-box;
`;

type Props = {
  category?: object;
  // @ts-expect-error ts-migrate(2749) FIXME: 'node' refers to a value, but is being used as a t... Remove this comment to see the full error message
  description?: node;
  // @ts-expect-error ts-migrate(2749) FIXME: 'array' refers to a value, but is being used as a ... Remove this comment to see the full error message
  locations?: object | array;
  // @ts-expect-error ts-migrate(2749) FIXME: 'array' refers to a value, but is being used as a ... Remove this comment to see the full error message
  tiles?: array;
  title?: string;
  userProfile?: object;
  eventName?: string;
  className?: string;
  insuranceDetails?: object;
};

class TileList extends PureComponent<Props> {
  render = () => {
    const { category, tiles, userProfile, eventName, className } = this.props;

    const columnCount = getColumnCount(category);

    return (
      // @ts-expect-error ts-migrate(2769) FIXME: Property 'columncount' does not exist on type 'Int... Remove this comment to see the full error message
      <Root className={className} columncount={columnCount}>
        {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'wrap' does not exist on type '(Intrinsic... Remove this comment to see the full error message */}
        <List cellHeight="auto" cols={columnCount} spacing={SWIMLANE_SPACING} wrap={0}>
          {tiles.map((tile: any, i: any) => (
            <GridTile
              key={`${i}-${tile.title}`}
              // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message
              sc={{ categoryId: category.id, tileStyle: category.tileStyle }}
            >
              <TileContainer>
                {TileFactory.getTile({
                  tileIndex: i,
                  tile,
                  userProfile,
                  eventName,
                  extraProps: this.props,
                })}
              </TileContainer>
            </GridTile>
          ))}
        </List>
      </Root>
    );
  };
}

export default TileList;
